module.exports = __webpack_public_path__ + "static/img/icon1.f55cbcaf.svg";